import React from 'react'

import { ConfirmModal, useModalContext } from '@fourthwall/components'
import { pluralize } from '@fourthwall/utils/dist/string'

import * as S from './ConfirmStoreDisconnectModal.styled'

export type StoreDisconnectType = 'DISCONNECT' | 'CHANGE_SHOP'

export type ConfirmStoreDisconnectModalProps = {
  type: StoreDisconnectType
  pendingFulfillmentsCount?: number
  onConfirm: () => void
}

export const ConfirmStoreDisconnectModal = ({
  type,
  pendingFulfillmentsCount,
  onConfirm,
}: ConfirmStoreDisconnectModalProps) => {
  const { close } = useModalContext()

  const title =
    type === 'DISCONNECT'
      ? 'Are you sure you want to disconnect from ShipStation store?'
      : 'Are you sure you want to change ShipStation store?'

  const text = pendingFulfillmentsCount ? (
    <>
      You currently have {pendingFulfillmentsCount} pending{' '}
      {pluralize(pendingFulfillmentsCount, 'order')}. Changing ShipStation store will lose tracking
      of these orders. <S.Strong>This action cannot be reverted.</S.Strong>
    </>
  ) : undefined

  return (
    <ConfirmModal
      title={title}
      text={text}
      confirmAppearance="destructive"
      onConfirm={onConfirm}
      close={close}
    />
  )
}
